import { useI18n } from "vue-i18n";

interface AuditStateParams {
  value: string;
  color: string;
  lightColor: string;
}

export class AuditState {
  value: string;
  color: string;
  lightColor: string;

  static states: AuditState[] = [
    new AuditState({
      value: "Added",
      color: "#2563EB",
      lightColor: "#EFF4FF",
    }),
    new AuditState({
      value: "Modified",
      color: "#1FA85B",
      lightColor: "#E8F6EE",
    }),
    new AuditState({
      value: "Deleted",
      color: "#DC2626",
      lightColor: "#FEF2F2",
    }),
  ];

  constructor({ value, color, lightColor }: AuditStateParams) {
    this.value = value;
    this.color = color;
    this.lightColor = lightColor;
  }

  static getaudittateByValue(value: string): AuditState {
    switch (value) {
      case AuditState.states[0].value:
        return AuditState.states[0];
      case AuditState.states[1].value:
        return AuditState.states[1];
      case AuditState.states[2].value:
        return AuditState.states[2];
      default:
        throw new Error("Value is out range of AuditState");
    }
  }

  getLocalization(): string {
    const { t } = useI18n();
    switch (this.value) {
      case AuditState.states[0].value:
        return t("audit.states.added");
      case AuditState.states[1].value:
        return t("audit.states.modified");
      case AuditState.states[2].value:
        return t("audit.states.deleted");
      default:
        return this.value;
    }
  }
}
